import React, { createContext, useContext, useEffect, useState } from "react";
import { dict } from "@/i18n/dict";

const I18nContext = createContext({ lang: "de", t: dict.de, setLang: () => {} });

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("itsp_lang") || "de");
  useEffect(() => {
    localStorage.setItem("itsp_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const value = { lang, t: dict[lang], setLang };
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
